import {
    AfterViewInit,
    Component,
    EventEmitter,
    Input,
    OnChanges,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {AbstractControl, FormControl, UntypedFormGroup} from '@angular/forms';
import {SelectFilterComponent} from '../../../../../../components/common/select-filter/select-filter.component';
import {AccountingAccountModel} from '../../entity/accountingAccount.model';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {MultipleSelectFilterComponent} from '../../../../../core/component/multiple-select-filter/multiple-select-filter.component';
import {AccountingAccountFindAllService} from '../../service/accountingAccountFindAll.service';

@Component({
    selector: 'app-accounting-account-select-filter',
    templateUrl: './accounting-account-select-filter.component.html',
    providers: [AccountingAccountFindAllService]
})
export class AccountingAccountSelectFilterComponent implements OnChanges, AfterViewInit {

    loading: boolean;

    @ViewChild('selectFilter') selectFilterComponent: SelectFilterComponent<number, AccountingAccountModel>;
    @ViewChild('multipleSelectFilter') multipleSelectFilterComponent: MultipleSelectFilterComponent<number, AccountingAccountModel>;

    @Input() accountIdToIgnore: number;
    @Input() selectFirstElement = true;
    @Input() single = true;
    @Input() parentFormGroup: UntypedFormGroup;
    @Input() parentFormControlName: string;
    @Input() noValueLabel: 'Aucun compte';
    @Input() typeValue: string;
    @Output() _onSingleSelectionChange = new EventEmitter<AccountingAccountModel>();
    @Output() _onMultipleSelectionChange = new EventEmitter<AccountingAccountModel[]>();
    @Output() elementsChangeEvent = new EventEmitter<AccountingAccountModel[]>();

    elements: BehaviorSubject<SelectFilterElement<number, AccountingAccountModel>[]> =
        new BehaviorSubject<SelectFilterElement<number, AccountingAccountModel>[]>([]);
    entities: AccountingAccountModel[] = [];
    constructor(private service: AccountingAccountFindAllService) {
    }

    ngAfterViewInit(): void {
        this.refresh();
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['typeValue'] || changes['accountIdToIgnore']) {
            this.emitElements();
        }
    }


    refresh() {
        this.loading = true;
        this.service.findAll()
            .then((entities) => {
                this.entities = entities;
                this.emitElements();
            })
            .finally(() => this.loading = false);
    }

    private emitElements() {
        console.log([this.accountIdToIgnore, this.entities])
        const filteredEntities = this.entities
            .filter(value => !this.typeValue || value?.type?.value === this.typeValue)
            .filter(value => !this.accountIdToIgnore || value.id !== this.accountIdToIgnore);
        this.elements.next(
                filteredEntities
                .map(value => new SelectFilterElement(value.id, value.id, value)));

        this.elementsChangeEvent.emit(filteredEntities);
        if (filteredEntities.length > 0) {
             if (!this.control.value || filteredEntities.findIndex(value => value.id === this.control.value) < 0) {
                 if (this.selectFirstElement === true) {
                     if (this.single === true) {
                        this.control.setValue(filteredEntities[0].id);
                    } else {
                        this.control.setValue([filteredEntities[0].id]);
                    }
                 }
             }
        }

    }

    filter = (criteria: string, entity: AccountingAccountModel) => {
        const name = entity.name + ' ' + entity.type.label;
        return (name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
    }

    selectionChanged(value: SelectFilterElement<number, AccountingAccountModel>) {
        if (value) {
            this._onSingleSelectionChange.emit(value.element);
        }
    }

    multipleSelectionChanged(values: AccountingAccountModel[]) {
        this._onMultipleSelectionChange.emit(values);
    }

    public getSelectedElement(): AccountingAccountModel {
        return this.selectFilterComponent?.getSelectedElement();
    }

    public getSelectedElements(): AccountingAccountModel[] {
        return this.multipleSelectFilterComponent?.getSelectedElements();
    }

    get control(): AbstractControl {
        return this.parentFormGroup.get(this.parentFormControlName);
    }

}
